export const preventDefault = (event: Event | CustomEvent): void => {
  event.preventDefault();
};
